export const SET_NOTE = "SET_NOTE";
export const SET_NOTE_TITLE = "SET_NOTE_TITLE";
export const SET_COLOR = "SET_COLOR";
export const SET_LABEL = "SET_LABEL";
export const SET_IN_TRASH = "SET_IN_TRASH";
export const SET_PRIORITY = "SET_PRIORITY";
export const SET_STARRED = "SET_STARRED";
export const SET_TAGS = "SET_TAGS";
export const RESET = "RESET";
